<template>
    <div class="search-bar h-block bg-white border-b border-50 flex items-center">

        <input
            v-debounce="search"
            type="text"
            class="flex-1 input-search h-full"
            :placeholder="$t('Search')"
        />

        <button
            v-if="showFilterButton"
            type="button"
            class="h-block w-block"
            @click="$emit('filter')"
        >
            <FilterIcon />
        </button>

    </div>
</template>

<script>
import FilterIcon from '@mobile/components/Icons/FilterIcon.vue';
import debounce from '@/directives/debounce';

export default {

    components: { FilterIcon },

    directives: {
        debounce,
    },

    props: {
        showFilterButton: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        search(search) {
            this.$emit('search', search);
        },
    },
};
</script>
